var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.08,
    height: 92.08,
    viewBox: "0 0 92.08 92.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 17.52,
    y1: 77.15,
    x2: 77.62,
    y2: 11.59,
    gradientTransform: "translate(7.99 -6.8) rotate(9.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a4ea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ed365b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ed365b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb415"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.04,
    cy: 46.04,
    r: 46.04,
    transform: "translate(-6.8 7.99) rotate(-9.24)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46,18.4c-7.51,0-8.45,0-11.4.17a20.18,20.18,0,0,0-6.7,1.28,14.14,14.14,0,0,0-8.09,8.09,20.18,20.18,0,0,0-1.28,6.7c-.14,3-.17,3.89-.17,11.4s0,8.45.17,11.39a20.25,20.25,0,0,0,1.28,6.71,14.14,14.14,0,0,0,8.09,8.09,20.18,20.18,0,0,0,6.7,1.28c3,.13,3.89.17,11.4.17s8.45,0,11.39-.17a20.25,20.25,0,0,0,6.71-1.28,14.14,14.14,0,0,0,8.09-8.09,20.25,20.25,0,0,0,1.28-6.71c.13-2.94.17-3.88.17-11.39s0-8.45-.17-11.4a20.18,20.18,0,0,0-1.28-6.7,14.14,14.14,0,0,0-8.09-8.09,20.25,20.25,0,0,0-6.71-1.28c-2.94-.14-3.88-.17-11.39-.17ZM64.11,31.29h0A3.32,3.32,0,1,1,60.79,28a3.32,3.32,0,0,1,3.32,3.32ZM46,55.25h0A9.21,9.21,0,1,1,55.25,46,9.21,9.21,0,0,1,46,55.25Zm0-23.4h0A14.19,14.19,0,1,1,31.85,46,14.19,14.19,0,0,1,46,31.85Zm0-8.47h0c7.38,0,8.25,0,11.17.16a15.43,15.43,0,0,1,5.13,1,9.06,9.06,0,0,1,5.24,5.24,15.37,15.37,0,0,1,1,5.13c.13,2.92.16,3.79.16,11.17s0,8.25-.16,11.17a15.43,15.43,0,0,1-1,5.13,9.06,9.06,0,0,1-5.24,5.24,15.43,15.43,0,0,1-5.13,1c-2.92.13-3.79.16-11.17.16s-8.25,0-11.17-.16a15.37,15.37,0,0,1-5.13-1,9.06,9.06,0,0,1-5.24-5.24,15.43,15.43,0,0,1-1-5.13c-.13-2.92-.16-3.79-.16-11.17s0-8.25.16-11.17a15.37,15.37,0,0,1,1-5.13,9.06,9.06,0,0,1,5.24-5.24,15.37,15.37,0,0,1,5.13-1C37.79,23.41,38.66,23.38,46,23.38Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.8aff7bc7ee764fdd8fc1af8f7ef65308.svg";
export { ForwardRef as ReactComponent };